/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import axios from "axios";
import { Modal, ModalOverlay, ModalContent, ModalBody } from "@chakra-ui/modal";
import Card from "components/card";
import { Button } from "@chakra-ui/react";
import DisplayAmountWithDecimals from "./DisplayAmountWithDecimals";
import { TokenManager } from "utils/tokenManager";

const TradeRejectConfirmModal: React.FC<{
  dataToProcess: any;
  isOpen: boolean;
  onClose(): void;
  triggerReload(): void;
  setSwalProps: any;
}> = ({ isOpen, onClose, triggerReload, dataToProcess, setSwalProps }) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [reason, setReason] = useState<string>("");
  const [isConfirmed, setIsConfirmed] = useState<boolean>(false);
  const userRole = localStorage.getItem("userRole");

  const closeModal = async () => {
    setReason("");
    setIsConfirmed(false); // Reset checkbox when closing
    onClose();
  };

  const handleSubmit = async () => {
    if (!reason.trim()) {
      setSwalProps({
        show: true,
        icon: "warning",
        title: "Validation Error",
        html: "Please provide a reason for rejection.",
        showConfirmButton: true,
        didClose: () => {
          setSwalProps({});
        },
      });
      return;
    }

    try {
      setIsProcessing(true);

      const data = {
        username: localStorage.getItem("username"),
        userRole: userRole,
        id: dataToProcess.id,
        shortid: dataToProcess.shortid,
        subaccountName: dataToProcess.subaccount.name,
        status: "rejected",
        reason: reason.trim()
      }

      await axios.post(process.env.REACT_APP_API_URL + `/api/${userRole.toLowerCase()}/trade/action/update-trade-status`, data)
        .then(function (response) {
          if (response && response.data?.status === 'ok') {
            closeModal();
            setSwalProps({
              show: true,
              icon: "success",
              title: "Success",
              html: "Trade has been marked as rejected",
              showConfirmButton: true,
              didClose: () => {
                triggerReload();
                setSwalProps({});
                setIsProcessing(false);
              },
            });
          } else {
            setIsProcessing(false);
          }
        })
        .catch(function (error) {
          setIsProcessing(false);
          setSwalProps({
            show: true,
            icon: "error",
            title: "Oops!",
            html: error.response.data.message,
            showConfirmButton: true,
            didClose: () => {
              setSwalProps({});
              setIsProcessing(false);
            },
          });
        });
    } catch (error: any) {
      setIsProcessing(false);
      setSwalProps({
        show: true,
        icon: "error",
        title: "Oops!",
        html: "Something went wrong, please try again later.",
        showConfirmButton: true,
        didClose: () => {
          setSwalProps({});
          setIsProcessing(false);
        },
      });
    }
  };

  const formatDate = (timestamp: string) => {
    if (!timestamp) return "-";
    const date = new Date(parseInt(timestamp));
    return date.toLocaleString();
  };

  const formatStatus = (status: string) => {
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  const formatAddress = (address?: string): string => {
    if (!address || address.length < 24) return "N/A";
    return `${address.slice(0, 15)}...${address.slice(-9)}`;
  };

  const isFormValid = reason.trim() !== "" && isConfirmed;

  return (
    <>
      {dataToProcess && (
        // <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        //     <ModalOverlay className="bg-[#000] !opacity-30" />
        //     <ModalContent className="!z-[1002] !m-auto !w-max min-w-[350px] !max-w-[85%] md:top-[12vh]">
        //         <ModalBody className="!text-navy-700">
        //             <Card extra="px-[30px] pt-[35px] pb-[40px] max-w-[650px] flex flex-col !z-[1004]">
        //                 <h1 className="mb-[20px] text-2xl font-bold">Mark Rejected Confirmation</h1>
        //                 <div className="mb-[20px] text-sm">
        //                     <div className="mb-8">
        //                         You're about to mark this trade as rejected. This action cannot be undone.
        //                     </div>
        //                     <div className="mb-1">
        //                         <span>Code:</span>
        //                         <span className="ml-3 font-semibold">{dataToProcess.shortid}</span>
        //                     </div>
        //                     {userRole === "superadmin" &&
        //                         <div className="mb-1">
        //                             <span>Subaccount:</span>
        //                             <span className="ml-3 font-semibold">{dataToProcess.subaccount.name}</span>
        //                         </div>
        //                     }
        //                     <div className="mb-1">
        //                         <span>Pair:</span>
        //                         <span className="ml-3 font-semibold">{`${dataToProcess.from_asset}/${dataToProcess.to_asset} (${dataToProcess.to_network})`}</span>
        //                     </div>
        //                     <div className="mb-1">
        //                         <span>Amount:</span>
        //                         <span className="ml-3 font-semibold">
        //                             {dataToProcess.from_network === "fiat" ? (
        //                                 <DisplayAmountWithDecimals
        //                                     amount={Number(dataToProcess.from_amount)}
        //                                     currency={dataToProcess.from_asset}
        //                                     decimal={dataToProcess?.from_asset_decimal}
        //                                 />
        //                             ) : (
        //                                 dataToProcess.from_amount
        //                             )}
        //                             &nbsp;{dataToProcess.from_asset}
        //                         </span>
        //                     </div>
        //                     <div className="mb-1">
        //                         <span>To Address:</span>
        //                         <span className="ml-3 font-semibold">
        //                             {`${dataToProcess.to_address.nickname} (${formatAddress(dataToProcess.to_address.address)})`}
        //                         </span>
        //                     </div>
        //                     <div className="mb-1">
        //                         <span>Ref.</span>
        //                         <span className="ml-3 font-semibold">
        //                             {dataToProcess.reference}
        //                         </span>
        //                     </div>
        //                 </div>
        //                 <div className="mb-6">
        //                     <label className="mb-1 block text-sm font-bold text-navy-700 dark:text-white">
        //                         Reason *
        //                     </label>
        //                     <textarea
        //                         disabled={isProcessing}
        //                         className="mb-3 mt-2 text-sm shadow-sm border text-primary rounded-md p-2 block w-full bg-white border-gray-300 h-28 resize-none overflow-auto focus:outline-none"
        //                         id="reason"
        //                         autoComplete="off"
        //                         value={reason}
        //                         onChange={(e) => setReason(e.target.value)}
        //                         placeholder="Enter reason for rejection"
        //                     />
        //                 </div>

        //                 {/* Confirmation Checkbox */}
        //                 <div className="flex items-start gap-3 rounded-lg border border-gray-200 dark:border-white/10 p-4 mb-4">
        //                     <input
        //                         type="checkbox"
        //                         id="confirmReject"
        //                         checked={isConfirmed}
        //                         onChange={(e) => setIsConfirmed(e.target.checked)}
        //                         disabled={isProcessing}
        //                         className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
        //                     />
        //                     <label htmlFor="confirmReject" className="text-sm text-navy-700 dark:text-white cursor-pointer">
        //                         I have carefully reviewed this trade and confirm that the rejection reason provided is accurate. I understand that this action cannot be undone.
        //                     </label>
        //                 </div>

        //                 <div className="flex gap-2 justify-end">
        //                     <Button
        //                         onClick={() => closeModal()}
        //                         isDisabled={isProcessing}
        //                         className="btn btn-default"
        //                     >
        //                         Not now
        //                     </Button>
        //                     <Button
        //                         isDisabled={!isFormValid || isProcessing}
        //                         onClick={() => handleSubmit()}
        //                         isLoading={isProcessing}
        //                         loadingText='Processing...'
        //                         className="btn text-white bg-red-600 hover:bg-red-500 disabled:bg-gray-400 disabled:cursor-not-allowed">
        //                         Mark Rejected
        //                     </Button>
        //                 </div>
        //             </Card>
        //         </ModalBody>
        //     </ModalContent>
        // </Modal>

        <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
          <ModalOverlay className="!bg-black/40" />
          <ModalContent className="dark:!bg-neutral-900 !z-[1002] !m-auto !w-full max-w-xl !rounded-2xl !border !border-gray-200 !bg-white !shadow-xl dark:!border-white/10 md:!top-[12vh]">
            <ModalBody className="p-6 md:p-7">
              <div className="mb-4 flex items-start gap-3">
                <div className="rounded-xl bg-red-50 p-2 text-red-600 ring-1 ring-red-100 dark:bg-red-900/20 dark:text-red-400 dark:ring-red-900/30">
                  <svg
                    viewBox="0 0 24 24"
                    className="h-5 w-5"
                    fill="currentColor"
                  >
                    <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm3.71 12.29a1 1 0 01-1.42 1.42L12 13.41l-2.29 2.3a1 1 0 01-1.42-1.42L10.59 12l-2.3-2.29a1 1 0 011.42-1.42L12 10.59l2.29-2.3a1 1 0 011.42 1.42L13.41 12z" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-lg font-semibold text-gray-900 dark:text-white">
                    Mark Rejected — Confirmation
                  </h1>
                  <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
                    Review the details below before confirming. This action is
                    permanent.
                  </p>
                </div>
              </div>

              <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-900/40 dark:bg-red-900/20 dark:text-red-300">
                You are about to mark this trade as{" "}
                <span className="font-medium">rejected</span>. This cannot be
                undone.
              </div>

              <div className="dark:bg-neutral-800/50 mb-6 rounded-xl bg-gray-50 p-4 ring-1 ring-gray-100 dark:ring-white/10">
                <dl className="flex flex-col gap-3 text-sm">
                  <div className="flex">
                    <dt className="w-28 shrink-0 text-gray-700 dark:text-gray-400">
                      Code
                    </dt>
                    <dd className="font-medium text-gray-900 dark:text-white">
                      {dataToProcess.shortid}
                    </dd>
                  </div>

                  {userRole === "superadmin" && (
                    <div className="flex">
                      <dt className="w-28 shrink-0 text-gray-700 dark:text-gray-400">
                        Subaccount
                      </dt>
                      <dd className="font-medium text-gray-900 dark:text-white">
                        {dataToProcess.subaccount.name}
                      </dd>
                    </div>
                  )}

                  <div className="flex">
                    <dt className="w-28 shrink-0 text-gray-700 dark:text-gray-400">
                      Pair
                    </dt>
                    <dd className="font-medium text-gray-900 dark:text-white">
                      {`${dataToProcess.from_asset}/${dataToProcess.to_asset} (${dataToProcess.to_network})`}
                    </dd>
                  </div>

                  <div className="flex">
                    <dt className="w-28 shrink-0 text-gray-700 dark:text-gray-400">
                      Amount
                    </dt>
                    <dd className="font-medium text-gray-900 dark:text-white">
                      {dataToProcess.from_network === "fiat" ? (
                        <DisplayAmountWithDecimals
                          amount={Number(dataToProcess.from_amount)}
                          currency={dataToProcess.from_asset}
                          decimal={dataToProcess?.from_asset_decimal}
                        />
                      ) : (
                        dataToProcess.from_amount
                      )}{" "}
                      {dataToProcess.from_asset}
                    </dd>
                  </div>

                  <div className="flex md:col-span-2">
                    <dt className="w-28 shrink-0 text-gray-700 dark:text-gray-400">
                      To Address
                    </dt>
                    <dd className="font-medium text-gray-900 dark:text-white">
                      {`${dataToProcess.to_address.nickname} (${formatAddress(
                        dataToProcess.to_address.address
                      )})`}
                    </dd>
                  </div>

                  <div className="flex md:col-span-2">
                    <dt className="w-28 shrink-0 text-gray-700 dark:text-gray-400">
                      Reference
                    </dt>
                    <dd className="font-medium text-gray-900 dark:text-white">
                      {dataToProcess.reference}
                    </dd>
                  </div>
                </dl>
              </div>

              <div className="mb-5">
                <label
                  htmlFor="reason"
                  className="mb-1 block text-sm font-medium text-gray-800 dark:text-gray-100"
                >
                  Reason <span className="text-red-500">*</span>
                </label>
                <textarea
                  id="reason"
                  disabled={isProcessing}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Enter reason for rejection"
                  className="dark:bg-neutral-900 block h-16 w-full resize-none rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 shadow-sm outline-none ring-red-600/0 placeholder:text-gray-400 focus:border-red-600 focus:ring-2 focus:ring-red-600/20 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:text-white"
                />
              </div>

              <div className="mb-6 rounded-xl border border-gray-200 p-4 text-sm dark:border-white/10">
                <label className="flex cursor-pointer items-start gap-3">
                  <input
                    type="checkbox"
                    id="confirmReject"
                    checked={isConfirmed}
                    onChange={(e) => setIsConfirmed(e.target.checked)}
                    disabled={isProcessing}
                    className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500 disabled:opacity-60"
                  />
                  <span className="text-gray-700 dark:text-gray-200">
                    I confirm that I have carefully reviewed this trade and the
                    rejection reason provided is accurate. I understand that
                    this action cannot be undone.
                  </span>
                </label>
              </div>

              <div className="flex justify-end gap-2">
                <Button
                  onClick={() => closeModal()}
                  isDisabled={isProcessing}
                  className="dark:bg-neutral-900 dark:hover:bg-neutral-800 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500/20 dark:border-white/10 dark:text-white"
                >
                  Not now
                </Button>

                <Button
                  isDisabled={!isFormValid || isProcessing || TokenManager.isImpersonating()}
                  onClick={() => handleSubmit()}
                  isLoading={isProcessing}
                  loadingText="Processing..."
                  className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/30 disabled:cursor-not-allowed disabled:bg-gray-400"
                >
                  Mark Rejected
                </Button>
              </div>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default TradeRejectConfirmModal;
